/**
 * Contains customizations to the header component:
 * - allows for activating the mega menu dropdown on hover. This is enabled only
 *   when the screen width is greater than 990px outside of the Shopify CMS.
 *
 * Do note that there is a matching brand-header.css file in the assets folder
 * that contains relevant styles used with this customizations.
 */

const BrandHeader = {
  SELECTORS: {
    inlineMenuDetailsElement: '.header__inline-menu details, .header__account details',
  },
  init() {
    this.initializeInlineMenuDetailsHoverTrigger();
  },
  initializeInlineMenuDetailsHoverTrigger() {
    const ACTIVE_BREAKPOINT_WIDTH = 990;

    const inlineMenuDetailsElements = document.querySelectorAll(this.SELECTORS.inlineMenuDetailsElement);

    inlineMenuDetailsElements.forEach((element) => {
      element.onmouseenter = () => {
        if (window.innerWidth < ACTIVE_BREAKPOINT_WIDTH || Shopify.designMode) {
          return;
        }

        const summaryElement = element.querySelector('summary');

        if (summaryElement) {
          element.open = true;

          summaryElement.ariaExpanded = true;
        }
      };

      element.onmouseleave = () => {
        if (window.innerWidth < ACTIVE_BREAKPOINT_WIDTH || Shopify.designMode) {
          return;
        }

        const summaryElement = element.querySelector('summary');

        if (summaryElement) {
          element.open = false;

          summaryElement.ariaExpanded = false;
        }
      };
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  BrandHeader.init();
});

document.addEventListener('shopify:section:load', () => {
  BrandHeader.init();
});

document.addEventListener('shopify:section:reorder', () => {
  BrandHeader.init();
});
